import styled from "styled-components";
import { viewPortSize } from "../../../../graph/base/helpers";

const disabledStyles = isDisabled => {
  if (isDisabled) {
    return `
      height: auto;
      width: inherit;
      opacity:1;
      position:relative;
      z-index:997;
      @media (max-width: ${viewPortSize.mobile}px) {
        width:100%
        position: relative;
        width: initial;
        height: initial;
      }`;
  }
};
const UIWidgetsLoader = styled.div`
  ${p => disabledStyles(p.isDisabled)};
`;

export default UIWidgetsLoader;
